/* @flow */

export const HAPPY = 'HAPPY';
export const SMILE = 'SMILE';
export const NEUTRAL = 'NEUTRAL';
export const SAD = 'SAD';
export const DIZZY = 'DIZZY';

export type SmileyVariantType =
  | typeof HAPPY
  | typeof SMILE
  | typeof NEUTRAL
  | typeof SAD
  | typeof DIZZY;
